export default __webpack_public_path__ + "static/media/we-help-our-clients.3f930419.jpg";